import React, { useEffect, useRef, useState } from "react";

const TextInput = ({
  divClassName = "",
  inputClassName = "",
  startIcon,
  endIcon,
  defaultType = "text",
  defaultValue = "",
  value,
  onChange,
  ...props
}) => {
  const [type, setType] = useState(props.type)
  const [realEndIcon, setRealEncIcon] = useState(endIcon)
  const inputRef = useRef(null)

  useEffect(() => {
    setType(defaultType)
  }, [defaultType])

  const toggleType = () => {
    if (type === "password"){
      setType('text')
      setRealEncIcon(<img src='/assets/icons/icon-eye-slash-visible.svg' />)
    }
    
    if (type === "text"){
      setType('password')
      setRealEncIcon(<img src='/assets/icons/icon-eye-slash.svg' />)
    }
  }

  const openCalendar = () => {
    inputRef.current.focus()

    setTimeout(() => {
      inputRef.current.click()
    }, 100);
  }

  const handleMouseWheel = (e) => {
    const inputElement = inputRef.current;

    const handleWheel = (e) => {
      e.preventDefault();
    };

    // Add the wheel event listener with passive: false
    inputElement.addEventListener('wheel', handleWheel, { passive: false });

    // Cleanup function to remove the event listener
    return () => {
      inputElement.removeEventListener('wheel', handleWheel);
    };
  }

  return (
    <div
      className={`w-full flex items-center border-[1px] border-gray text-xs rounded-[6px] ${divClassName}`}
    >
      {startIcon && <button className="ml-6">{startIcon}</button>}
      <input
        className={`!bg-transparent text-white p-4 px-6 w-full placeholder:text-white ${inputClassName}`}
        value={value !== undefined ? value : defaultValue || ""}
        {...props}
        type={type}
        onChange={(e) => onChange && onChange(e.target.value)}
        ref={inputRef}
        onWheel={handleMouseWheel}
      />
      {endIcon ?
        type === 'date' ?
          <button className="mr-6" onClick={openCalendar}>{realEndIcon}</button>
          :
          < button className="mr-6" onClick={toggleType}>{realEndIcon}</button>
        : ""
      }
    </div >
  )
};

export default TextInput;
